// Core
import { useState } from 'react';
import { Box, Flex, Grid, Text, Image, Skeleton, Button } from '@chakra-ui/react';
import { useSpring, animated } from '@react-spring/web';
import { useDrag } from '@use-gesture/react';
import { RiMessage3Fill, RiProfileFill } from 'react-icons/ri';
import { FaHeart, FaUser } from 'react-icons/fa';
import { IoLocationSharp, IoCloseOutline } from 'react-icons/io5';
import { IoIosClose } from 'react-icons/io';
import { MdCancel } from 'react-icons/md';
import { useQuery } from 'react-query';

// Assets
import { apiService } from 'services/ApiService';
import { validateLoadMore } from 'services/Utils';
import { textLang } from 'services/Lang';

const ApprovedGroup = ({
	setShowInfo,
	setShowInfoType,
	setItem
}) => {
	const limit = 20;
  const [list, setList] = useState([]);
  const [listMeta, setListMeta] = useState({total: 0, limit, offset}); 
  const [offset, setOffset] = useState(0);  
  const [isLoadingButton, setIsLoadingButton] = useState(false);

	const { isFetching: isFetchingList } = useQuery({
    queryKey: ['list-me-approved', offset],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const params = {
        limit, 
        offset
      };

      const response = await apiService.getGroupsApproved(params);
      setIsLoadingButton(false);
      if(offset === 0){
          setList(response.data);
      } else {
          setList([...list, ...response.data]);
      }

      setListMeta(response.meta);
      return true;
    },
    retry: false
  });
 
  const loadMore = async () => {
    setOffset(offset + limit);
  };

  return (
    <Box mt="50px">
      <Text variant="title-lg" 
          fontWeight="800"
          textTransform="uppercase"
          fontSize="24px">{textLang('approved')}</Text>
        <Grid mt="16px" alignItems="top" templateColumns={{ base: '1fr 1fr', md: '1fr 1fr 1fr 1fr 1fr' }} gap="16px" templateRows='1fr' zIndex="2">
        	{ list.map((item, index) => (
        		<Box key={index} w="100%" onClick={() => { setShowInfo(true); setShowInfoType('approved'); setItem(item?.group); }}>
		            <Box borderRadius="20px" w="100%" sx={{aspectRatio: '1'}} position="relative">
	            		<Image 
	            			src={item?.image} 
	            			w="100%" h="100%"
	            			objectFit="cover" 
	            			/>
	            		<Text
	            			w="100%" 
	            			variant="title-lg"
	            			position="absolute"
	            			top="16px"
	            			left="16px"
	            			color="white"
	            			textShadow="1px 1px black"
								    bg="#f5f5f57d"
								    borderRadius="5px 0 0 5px"
								    p="2px 5px" 
								    noOfLines={2}
	            			>
	            			{item?.group?.name}
	            		</Text>
	        		</Box>
        		</Box>
	        ))}
        </Grid>

        { list?.length === 0 && !isFetchingList &&
          <Text px="10%" mt="40px" variant="title-lg" fontSize="18px" textAlign="center">
            {textLang('approved_none')}
          </Text>
        }

        { list?.length === 0 && isFetchingList && 
          <Grid mt="16px" alignItems="top" templateColumns={{ base: '1fr 1fr', md: '1fr 1fr 1fr 1fr 1fr' }} gap="16px" templateRows='1fr' zIndex="2">
            { Array.from({ length: 10 }).map((_, i) => (
              <Skeleton key={i} borderRadius="20px" w="100%" sx={{aspectRatio: '1'}} position="relative" />
            ))}
          </Grid>
        }

        { validateLoadMore(list, listMeta) && (
          <Button variant="solid-lg" onClick={loadMore} m="16px auto" display="block">
            {textLang('load_more')}
          </Button>
        )}
    </Box>
  );
};

export default ApprovedGroup;